import {dividendsTable, DividendsTable} from "./table/DividendsTableComponent";
import {dividendPayoutChart, DividendPayoutChart} from "./chart/DividendPayoutChartComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.dividend-components`;

    return angular.module(moduleName, [])
                  .component(DividendPayoutChart, dividendPayoutChart())
                  .component(DividendsTable, dividendsTable())
                  .name;
}
